var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 1.62132C12.4017 1.2235 12.9413 1 13.5039 1C14.0665 1 14.6061 1.2235 15.0039 1.62132C15.4017 2.01915 15.6252 2.55871 15.6252 3.12132C15.6252 3.68393 15.4017 4.2235 15.0039 4.62132L5.50391 14.1213L1.50391 15.1213L2.50391 11.1213L12.0039 1.62132Z",
    stroke: "#027A3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.3b07c269c5b24cb9a09f30cf1623950c.svg";
export { ForwardRef as ReactComponent };